// Same numeric padding convention as the backend; validation is enforced there.
export function formatCodiceAgo(value) {
  const codice = String(value ?? "").trim();
  return /^\d+$/.test(codice) ? codice.padStart(15, "0") : codice;
}
